import React, { Component } from 'react';
import './footer.css'

class Contact extends Component {
  render() {
    return (
      <footer>
        <section className="container footer-section">
            <div className="col-md-5 col-xs-12">©33Capital Group Limited. All right reserved.</div>
            <div className="col-md-7">
            </div>
        </section>
        <section className="ss-style-doublediagonal" data-type="background" data-speed="10">
        </section>
      </footer>
    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/components/Footer/index.js